import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';

import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { deleteRequest } from 'src/utils/request';
import { API } from 'src/reactQuery/Api';

import messages from '../../messages';

const deletePayroll = async (uuid: string) => {
  await deleteRequest(API.DELETE.deletePayroll(uuid));
};

export const useDeletePayroll = () => {
  const { handleError, handleSuccess } = useMessageHandler();
  const { formatMessage } = useIntl();
  const client = useQueryClient();

  return useMutation({
    mutationFn: deletePayroll,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: [QUERY_KEYS.PAYROLLS] });
      handleSuccess(formatMessage(messages.payrollDeleted));
    },
    onError: handleError,
  });
};
